import { animate, style, transition, trigger } from '@angular/animations';

export const Animations = [
  trigger('inOutAnimation', [
    transition('void => *', [style({ opacity: 0, height: 0 }), animate('300ms ease-out')]),
    transition('* => void', [animate('300ms ease-out', style({ opacity: 0, height: 0 }))]),
  ]),
];
